import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const WishlistSkeleton: React.FC = () => (
  <div data-testid="wishlist-skeleton">
    <Skeleton className="h-[400px]" />
  </div>
);
